<template>
  <div class="page-content aizbIndex" style="min-height: 90vh;" v-loading="loading">
    <div class="startTitle">微模态</div>
    <el-row style="margin-top: 20px">
      <el-col :span="6" v-for="(item,index) in AIDiagnosisList" :key="index">
        <div class="itemBox">
          <img :src="item.pcImg" alt="">
          <div class="aginzBtn" @click="toAiTable(item.name,item.diseaseType)">查看详情</div>
          <div class="useNum">已诊测：{{item.count}}次</div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import '@/assets/css/backcommon.css'
import Cookies from 'js-cookie'
import baseAPI from "@/api/baseAPI";
import { AIDiagnosis } from "@/api/dataReport"
export default {
  name: "aizbIndex",
  data() {
    return {
      loading: true,
      AIDiagnosisList: []
    }
  },
  components: {},
  mounted() {
    this.AIDiagnosis()
  },
  methods: {
    toAiTable(name, diseaseType) {
      this.$router.push("/personCenter/aizbIndex/aizbTable?name=" + name + "&diseaseType=" + diseaseType);
    },
    AIDiagnosis() {
      this.loading = true;
      AIDiagnosis().then(res => {
        console.log(res);
        this.loading = false;
        this.AIDiagnosisList = res.data.rows;
      })
    }
  },
}

</script>
<style scoped>
.aizbIndex .itemBox {
  position: relative;
  height: 200px;
  border: 1px solid #EDEDED;
}

.aizbIndex .el-col {
  margin-right: 14px;
  margin-bottom: 20px;
}

.aizbIndex .el-col-6 {
  width: 24%;
}

.aizbIndex .el-col.mr0 {
  margin-right: 0;
}

.aizbIndex .itemBox {
  cursor: pointer;
}

.aizbIndex .itemBox img {
  padding: 6px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  width: 100%;
  height: 100%;
}

.aizbIndex .itemBox .aginzBtn {
  border-radius: 5px;
  position: relative;
  top: 95px;
  width: 105px;
  height: 30px;
  line-height: 30px;
  color: #000000;
  margin: 0 auto;
  font-size: 13px;
  background-color: #ffffff;
  text-align: center;
  opacity: 0;
  transition: opacity 0.5s;
  -webkit-transition: opacity 0.5s;
  /* Safari */
}

.itemBox:hover .aginzBtn {
  opacity: 1;
  z-index: 999;
}

.aizbIndex .itemBox .useNum {
  position: relative;
  top: 105px;
  text-align: center;
  color: #ffffff;
  font-size: 13px;
  opacity: 0;
  transition: opacity 0.5s;
  -webkit-transition: opacity 0.5s;
  /* Safari */
}

.itemBox:hover .useNum {
  opacity: 1;
  z-index: 999;
}

</style>



// WEBPACK FOOTER //
// src/views/personCenter/aizbIndex.vue